import { EpiBlock } from '@api/types';
import { Progress } from '@components';
import { useEditMode } from '@hooks';
import { Alert, Box } from '@mui/material';
import { fullDateAndTime } from '@utils/index';

export type EditTitleProps = {
  blockTitle?: string;
  saved?: string;
  content?: EpiBlock[];
};

/**
 * Editing header / title for the block.
 * Should help understand what mode and version of block is displayed
 */
export const BlockEditorTitle = ({ content = [] }: EditTitleProps) => {
  const { inEditMode, isEditable, inCompareLeftPane, inCompareRightPane, ready } = useEditMode();

  const block = content[0];
  const data = block?.contentLink?.expanded;
  const blockTitle = block?.name || data?.name || 'block';

  // Primary title
  let title = '';

  if (inCompareLeftPane) {
    title = 'Edit and compare version';
  } else if (inCompareRightPane) {
    title = 'Compare with this version';
  } else if (inEditMode && isEditable) {
    title = `Edit ${blockTitle}`;
  } else if (inEditMode && !isEditable) {
    title = 'Static';
  }
  const isPreview = inEditMode && !isEditable;
  const showTitle = ready || isPreview || inCompareRightPane;

  // Secondary title
  const status = block?.status;
  let subtitle = '';
  if (status === 'Published') {
    subtitle = `Published - ${fullDateAndTime(block?.changed)}`;
  } else if (status === 'PreviouslyPublished') {
    subtitle = `Previously published - ${fullDateAndTime(block?.saved)}`;
  } else if (status === 'CheckedOut') {
    subtitle = `Draft - ${fullDateAndTime(block?.saved)}`;
  } else if (status === 'DelayedPublish') {
    subtitle = `Scheduled Publish - ${fullDateAndTime(block?.startPublish)}`;
  }

  return (
    <Alert severity='info'>
      {!showTitle && (
        <Box sx={{ margin: '0 auto' }}>
          <Progress size={24} />
        </Box>
      )}
      {showTitle && <b>{title}</b>}
      <Box>{subtitle}</Box>
    </Alert>
  );
};
